import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import app from 'flarum/forum/app';
import supportedLangs from './supportedLangs';

/*
 * The four §2 preference fields.
 *
 * They are presented as four separate controls on purpose. `reviewLangs` is a
 * commitment to REVIEW translations, not a display preference, and folding it
 * into the "languages I read" control would quietly enrol every reader as a
 * translation reviewer.
 */
export default class LanguageSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const user = app.session.user;
    this.sourceLang = user.attribute('sourceLang') || '';
    this.reviewLangs = (user.attribute('reviewLangs') || []).slice();
    this.readLangs = (user.attribute('readLangs') || []).slice();
    this.assistLang = user.attribute('assistLang') || '';
    this.assistEnabled = !!user.attribute('assistEnabled');
    this.saving = false;
  }

  view() {
    return (
      <div className="SfLangSettings">
        <div className="Form-group">
          <label>{app.translator.trans('scoreflection-translate.forum.settings.source')}</label>
          <p className="helpText">
            {app.translator.trans('scoreflection-translate.forum.settings.source_help')}
          </p>
          {this.select(this.sourceLang, (v) => (this.sourceLang = v))}
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('scoreflection-translate.forum.settings.review')}</label>
          <p className="helpText">
            {app.translator.trans('scoreflection-translate.forum.settings.review_help')}
          </p>
          {this.checkboxes(this.reviewLangs)}
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('scoreflection-translate.forum.settings.read')}</label>
          <p className="helpText">
            {app.translator.trans('scoreflection-translate.forum.settings.read_help')}
          </p>
          {this.checkboxes(this.readLangs)}
        </div>

        <div className="Form-group">
          <label>{app.translator.trans('scoreflection-translate.forum.settings.assist')}</label>
          {this.select(this.assistLang, (v) => (this.assistLang = v))}
          {Switch.component(
            {
              state: this.assistEnabled,
              onchange: (v) => (this.assistEnabled = v),
            },
            app.translator.trans('scoreflection-translate.forum.settings.assist_toggle')
          )}
        </div>

        {Button.component(
          { className: 'Button Button--primary', loading: this.saving, onclick: () => this.save() },
          app.translator.trans('scoreflection-translate.forum.settings.save')
        )}
      </div>
    );
  }

  select(value, onchange) {
    return (
      <select
        className="FormControl"
        value={value}
        onchange={(e) => {
          onchange(e.target.value);
        }}
      >
        <option value="">—</option>
        {supportedLangs().map((l) => (
          <option value={l}>{l.toUpperCase()}</option>
        ))}
      </select>
    );
  }

  /*
   * Order matters: readLangs order is the reader's own stated preference and is
   * the tie-break in §3 when two translations both qualify. So a newly ticked
   * language is APPENDED rather than slotted into the canonical list order.
   */
  checkboxes(list) {
    return (
      <div className="SfLangSettings-checks">
        {supportedLangs().map((l) => (
          <label className="checkbox">
            <input
              type="checkbox"
              checked={list.indexOf(l) !== -1}
              onchange={() => {
                const at = list.indexOf(l);
                if (at === -1) list.push(l);
                else list.splice(at, 1);
              }}
            />
            {l.toUpperCase()}
          </label>
        ))}
      </div>
    );
  }

  save() {
    this.saving = true;

    return app.session.user
      .save({
        sourceLang: this.sourceLang || null,
        reviewLangs: this.reviewLangs,
        readLangs: this.readLangs,
        assistLang: this.assistLang || null,
        assistEnabled: this.assistEnabled,
      })
      .then(() => {
        this.saving = false;
        app.alerts.show({ type: 'success' }, app.translator.trans('scoreflection-translate.forum.settings.saved'));
        m.redraw();
      })
      .catch(() => {
        this.saving = false;
        m.redraw();
      });
  }
}
